import {connect} from "react-redux";
import {Box, IconButton, Link} from "@mui/material";
import {selectLocks, selectNetwork, selectUser, selectUsers} from "../../../redux/selectors/firebase";
import {Locks} from "../../navbar/StateLock";
import {PathwayUser, Users} from "../../../redux/types/firebase";
import {useContext, useEffect, useState} from "react";
import {FirebaseContext} from "../../firebase/FirebaseProvider";
import {DataGridPro, GridRenderCellParams} from "@mui/x-data-grid-pro";
import {NetworkData} from "../../../fstn/network";
import {updateFocus, updateMode} from "../../../redux/slices/editor";
import {Lock} from "@mui/icons-material";

interface IProjectLocks {
    locks: Locks
    network: NetworkData
    project: string
    updateFocus: (state: string) => void,
    updateMode: (mode: string) => void,
    user: PathwayUser,
    users: Users
}
function ProjectLocks({locks, network, project, updateMode, updateFocus, user, users}: IProjectLocks) {
    const [data, setData] = useState<any>({});
    const {removeLock, trackUsers, untrack} = useContext(FirebaseContext);

    useEffect(() => {
        trackUsers();
        return () => untrack("users");
    }, [trackUsers, untrack]);
    // Clean up orphaned locks (those without a corresponding state
    useEffect(() => {
        if (network.states) {
            Object.keys(locks || {}).filter(key => network.states[key] === undefined).forEach(key =>
                removeLock(project, key)
            );
        }
    }, [network.states, locks, project, removeLock]);
    useEffect(() => {
        const renderLock = (params: GridRenderCellParams<string>) =>
            <IconButton color="primary" disabled={! user.roles.admin} onClick={() =>
                removeLock(project, params.value || "").catch(console.error)} size="small">
                <Lock/>
            </IconButton>
        const renderState = (params: GridRenderCellParams<string>) =>
            <Link onClick={() => {
                updateMode("graph");
                updateFocus(params.value || "")
            }} sx={{cursor: "pointer"}}>
                {network.states[params.value || ""]?.name || params.value}
            </Link>;

        setData({
            columns: [
                {field: "unlock", headerName: "Unlock", renderCell: renderLock, width: 60},
                {field: "user", headerName: "User", width: 150},
                {field: "created", headerName: "Created", width: 160},
                {field: "state", headerName: "State", renderCell: renderState, width: 160}
            ],
            dataset: "Locks",
            editable: false,
            rowHeight: 38,
            rowLength: "100%",
            rows: Object.entries(locks || {}).map(([key, lock]) => ({
                id: key,
                created: new Date(lock.created * 1000).toLocaleString(),
                state: key,
                unlock: key,
                user: (users && users[lock.user]?.name) || "Unknown"
            }))
        });
    }, [locks, network, project, removeLock, updateMode, updateFocus, user.roles, users]);
    if (!users) return null;
    return (
        <Box m={1} height="50vh">
            <DataGridPro {...data}/>
        </Box>
    );
}
const mapStateToProps = (store: never) => ({
    locks: selectLocks(store),
    network: selectNetwork(store),
    user: selectUser(store),
    users: selectUsers(store)
});

const connected = connect(mapStateToProps, {
    updateFocus,
    updateMode
})(ProjectLocks);

export { connected as ProjectLocks };